import { render, staticRenderFns } from "./CategoryCollection.vue?vue&type=template&id=17b20b6c&scoped=true&"
import script from "./CategoryCollection.vue?vue&type=script&lang=ts&"
export * from "./CategoryCollection.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCollection.vue?vue&type=style&index=0&id=17b20b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b20b6c",
  null
  
)

export default component.exports